import { motion, MotionValue, useInView, useMotionValueEvent, useScroll, useTransform } from 'framer-motion';
import React, { useRef } from 'react';
import Typewriter from './Effects/Typewritter';
import TestimonialsPresenter from './Testimonials/TestimonialsPresenter';

interface Props {
  isVisible: boolean;
}

const About: React.FC<Props> = (props) => {

  const { scrollYProgress } = useScroll();

  // Transform scroll progress (0 to 1) into color changes
  // const backgroundColor = useTransform(
  //   scrollYProgress,
  //   [0, 0.3, 0.7, 1], // Scroll range from start to end
  //   ["white", "black", "white", "white"]

  //   // ["#f0ebe3", "#fffafa", "#f0ebe3"] // Color transition from red to blue
  // );
  const backgroundColor = useTransform(
    scrollYProgress,
    [0, 0.5, 0.5, 1], // Key points in the scroll progress
    ["#f0ebe3", "#eeeeff", "#eeeeff", "#f0ebe3"] // Color transition with a stable green section
  );
  return (
    <section id="about" className="container h-auto mt-10 2xl:rounded-3xl" style={{display: props.isVisible ? 'flex' : 'none'}}>
      <div className="w-full h-full flex flex-col items-center rounded-3xl">
        <div className="about-us w-100 h-30 flex flex-col items-center">
          <h1 
            className="text-4xl font-bold md:text-6xl mt-10"
            >
              Coś o nas
          </h1>
          <motion.div className="line md:w-[40%] w-[60%] h-[3px] mt-2" 
            initial={{scaleX: 0}} 
            whileInView={{scaleX: 1}} 
            transition={{ duration: 1 }}
            viewport={{ margin: "-20%", once: true}} />
        </div>

        <motion.div className="h-auto w-screen flex gap-4 p-10 max-w-[1200px]">
          <p className="text-justify text-xl leading-relaxed ">
          <motion.span initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0}}
            transition={{ duration: 0.5 }}
            viewport={{ margin: "-20%", once: true}}>
            <motion.div className="lg:w-[300px] lg:h-[300px] w-[200px] h-[200px] rounded-full mr-5 float-start" style={{shapeOutside: 'circle()'}}>
              <img src="/Logo_resized.svg" alt="logo"/>
            </motion.div>
            <span>
              <br/>
              Gabinet powstał z myślą o wszystkich CUDOWNYCH dzieciakach 🤸‍♀, które potrzebują wsparcia w rozwoju.<br/>
              Chcemy aby w naszej przestrzeni zarówno dziecko jak i rodzic czuł się swobodnie i bezpiecznie.<br/>
              Pracujemy w oparciu o aktualną wiedzę, doświadczenie oraz dużą dozę empatii i dziecięcej radości.<br/>
              Pomagamy z trudnościami w mowie, komunikacji, umiejętnościach szkolnych, rozwoju poznawczym
              oraz radzeniu sobie z emocjami.<br/> 
              Sprawdź naszą ofertę!<br/>
              {/* <video autoPlay loop muted playsInline className="lg:w-[300px] lg:h-[300px] w-[200px] h-[200px] object-cover rounded-full shadow-lg float-end ml-2 mt-2" style={{shapeOutside: 'circle()'}}>
                <source src="/example_video.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video> */}
            </span>
          </motion.span>
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default About;